import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from 'atoms';
import HeaderRow from './HeaderRow';

const EmptyStateContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: clamp(12px, 2vw, 18px);
	width: 100%;
	max-width: min(264px, 80vw);
	height: auto;
	min-height: clamp(200px, 40vh, 268px);
	z-index: 2;
	padding: clamp(8px, 2vw, 16px);
	margin: 0 auto;
`;

const EmptyStateText = styled.div`
	font-size: clamp(13px, 2.5vw, 16px);
	color: #52525b;
	text-align: center;
	font-weight: 500;
	line-height: 1.4;
`;

const ResponsiveSVG = styled.svg`
	width: 100%;
	height: auto;
	max-width: min(250px, 70vw);
	max-height: min(205px, 35vh);
	display: block;
`;

const ResponsiveContainer = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	min-height: 100vh;
	width: 100%;
	padding: clamp(16px, 3vw, 32px) clamp(8px, 2vw, 16px) 0;
	box-sizing: border-box;
`;

export { EmptyStateText };

function IntercityEmptyState({ children }) {
	return (
		<ResponsiveContainer>
			<HeaderRow />
			<EmptyStateContainer>
				<ResponsiveSVG viewBox="0 0 250 205" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M124.713 204.74C175.405 204.74 216.5 197.062 216.5 187.59C216.5 178.118 175.405 170.439 124.713 170.439C74.0202 170.439 32.9258 178.118 32.9258 187.59C32.9258 197.062 74.0202 204.74 124.713 204.74Z"
						fill="#F5F5F7"
						fillOpacity="0.8"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M198.141 137.204L165.75 97.3399C164.196 95.4635 161.924 94.3276 159.532 94.3276H89.8896C87.4987 94.3276 85.2269 95.4635 83.6727 97.3399L51.2832 137.204V158.03H198.142V137.204H198.141Z"
						fill="#AEB8C2"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M78.7259 42.8765H170.697C172.133 42.8765 173.511 43.447 174.526 44.4626C175.542 45.4782 176.112 46.8556 176.112 48.2919V174.666C176.112 176.102 175.542 177.479 174.526 178.495C173.511 179.51 172.133 180.081 170.697 180.081H78.7259C77.2897 180.081 75.9123 179.51 74.8967 178.495C73.8811 177.479 73.3105 176.102 73.3105 174.666V48.2919C73.3105 46.8556 73.8811 45.4782 74.8967 44.4626C75.9123 43.447 77.2897 42.8765 78.7259 42.8765V42.8765Z"
						fill="#F5F5F7"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M90.704 56.3506H158.717C159.435 56.3506 160.124 56.6359 160.632 57.1437C161.14 57.6514 161.425 58.3402 161.425 59.0583V92.8463C161.425 93.5644 161.14 94.2531 160.632 94.7609C160.124 95.2687 159.435 95.554 158.717 95.554H90.704C89.9859 95.554 89.2972 95.2687 88.7894 94.7609C88.2816 94.2531 87.9963 93.5644 87.9963 92.8463V59.0583C87.9963 58.3402 88.2816 57.6514 88.7894 57.1437C89.2972 56.6359 89.9859 56.3506 90.704 56.3506ZM91.0587 110.253H158.363C159.175 110.253 159.954 110.575 160.528 111.15C161.102 111.724 161.425 112.503 161.425 113.315C161.425 114.127 161.102 114.906 160.528 115.481C159.954 116.055 159.175 116.378 158.363 116.378H91.0587C90.2465 116.378 89.4676 116.055 88.8933 115.481C88.3189 114.906 87.9963 114.127 87.9963 113.315C87.9963 112.503 88.3189 111.724 88.8933 111.15C89.4676 110.575 90.2465 110.253 91.0587 110.253ZM91.0587 126.178H158.363C159.175 126.178 159.954 126.501 160.529 127.075C161.103 127.65 161.426 128.429 161.426 129.241C161.426 130.054 161.103 130.833 160.529 131.407C159.954 131.982 159.175 132.304 158.363 132.304H91.0587C90.2463 132.304 89.4672 131.982 88.8928 131.407C88.3183 130.833 87.9956 130.054 87.9956 129.241C87.9956 128.429 88.3183 127.65 88.8928 127.075C89.4672 126.501 90.2463 126.178 91.0587 126.178ZM197.841 185.073C196.792 189.231 193.106 192.33 188.723 192.33H60.6986C56.3149 192.33 52.6297 189.23 51.5818 185.073C51.3819 184.281 51.281 183.467 51.2813 182.65V137.205H86.9119C90.8475 137.205 94.0196 140.519 94.0196 144.543V144.597C94.0196 148.619 97.2282 151.867 101.164 151.867H148.258C152.193 151.867 155.402 148.59 155.402 144.566V144.55C155.402 140.526 158.574 137.204 162.509 137.204H198.14V182.651C198.14 183.487 198.036 184.297 197.841 185.073Z"
						fill="#DCE0E6"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M202.32 45.0724L193.073 48.6601C192.836 48.7524 192.577 48.7759 192.327 48.7277C192.076 48.6795 191.845 48.5617 191.658 48.3877C191.472 48.2137 191.339 47.9907 191.274 47.7443C191.208 47.4979 191.214 47.2381 191.29 46.9948L193.913 38.5915C190.407 34.6057 188.35 29.7454 188.35 24.5006C188.35 10.9689 202.048 0 218.947 0C235.841 0 249.541 10.9689 249.541 24.5006C249.541 38.0323 235.843 49.0012 218.945 49.0012C212.815 49.0012 207.107 47.558 202.32 45.0724Z"
						fill="#DCE0E6"
					/>
					<path
						d="M230.999 28.9254C233.129 28.9254 234.856 27.2191 234.856 25.1143C234.856 23.0095 233.129 21.3032 230.999 21.3032C228.868 21.3032 227.142 23.0095 227.142 25.1143C227.142 27.2191 228.868 28.9254 230.999 28.9254Z"
						fill="white"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M210.75 28.4484H203.036L206.96 21.7793L210.75 28.4484ZM215.571 21.7793H222.32V28.4484H215.571V21.7793Z"
						fill="white"
					/>
				</ResponsiveSVG>
				{children || <EmptyStateText>No Ongoing Trips</EmptyStateText>}
			</EmptyStateContainer>
		</ResponsiveContainer>
	);
}

IntercityEmptyState.propTypes = {
	children: PropTypes.node,
};

export default IntercityEmptyState;
